export default __webpack_public_path__ + "static/media/illustration-final.cdc18763.svg";